module.exports = __webpack_public_path__ + "static/media/fireworks.ddd14645.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/fireworks.png
// module id = 2553
// module chunks = 0